import { useQuery } from '@tanstack/react-query'

import { getGuaranteeMoneyDepositsForAnOrganization } from '@src/api'
import { DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchGuaranteeMoneyDepositsForOrganization = (
  params: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () =>
      getGuaranteeMoneyDepositsForAnOrganization(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_GUARANTEE_MONEY_DEPOSITS_FOR_ORGANIZATION,
      params.organizationId,
    ],
  })
}
